import styled from 'styled-components'

import ArrowLeft from '@interco/icons/orangeds/MD/arrow-left'

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 0px 24px 0px 24px;
  z-index: 99999;
`

export const IArrowLeft = styled(ArrowLeft)`
  font-size: 24px;
  cursor: pointer;
`
